
import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';

import 'primereact/resources/themes/lara-light-indigo/theme.css'; 
import 'primereact/resources/primereact.min.css'; 
import 'primeicons/primeicons.css';

const Prueba = () => {

    return (
        <div className="wrapper">

            {/* Navbar */}
            <Navbar />

            {/* Sidebar */}
            <Sidebar />

            {/* Contenido */}
            <div
                className="content-wrapper"
                style={{
                    marginLeft: '250px',
                    padding: '20px',
                    minHeight: '100vh',
                    background: '#111'
                }}
            >
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-white">
                                    Sistema Externo
                                </h1>
                            </div>

                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <a href="/inicio">Inicio</a>
                                    </li>
                                    <li className="breadcrumb-item active text-gray">
                                        Login
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-12">

                                <div
                                    className="card"
                                    style={{
                                        background: '#000',
                                        border: '2px solid #444',
                                        boxShadow: '0 0 15px rgba(0,0,0,0.7)'
                                    }}
                                >

                                    <div
                                        className="card-header"
                                        style={{
                                            background: '#222',
                                            color: 'white'
                                        }}
                                    >
                                        <h3 className="card-title">
                                            <i className="pi pi-globe mr-2"></i>
                                            Portal de Acceso
                                        </h3>
                                    </div>

                                    <div
                                        className="card-body p-0"
                                        style={{
                                            height: '80vh'
                                        }}
                                    >
                                        <iframe
                                            src="http://189.195.162.46:21114/static/index.html#/user/login"
                                            width="100%"
                                            height="100%"
                                            frameBorder="0"
                                            title="Sistema Login"
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </section>

            </div>
        </div>
    );
};

export default Prueba;
